// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import CategoryParentReferenceResourceViewModel from '../../../../viewModel/resource/CategoryParentReferenceResourceViewModel';
import CategoryParentReferenceResourceDTO from '../../dto/resource/CategoryParentReferenceResourceDTO';

export default abstract class CategoryParentReferenceResourceModel extends BaseModel<CategoryParentReferenceResourceDTO> {
  /**
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.title = qs.title;
  }
}
